<template>
  <div style="height: 100%;display: flex;flex-direction: row;">
    <SalePlan @reload="detailKey++" style="width: 250px; height: unset; flex: unset;" @item-choose="item => chooseData = item" />
    <SaleDetail :key="detailKey" v-if="chooseData" :goodsSaleId="chooseData.id" style="flex: 1; width: 0;height: unset;margin-left: 0;padding: 0;" />
  </div>
</template>

<script>
import SaleDetail from './detail.vue'
import SalePlan from '../../components/goods/sale/plan.vue'

export default {
  components: { SalePlan, SaleDetail },
  props: {},
  data () {
    return {
      chooseData: null,
      detailKey: 0
    }
  }
}
</script>
